import { render, staticRenderFns } from "./DuplicatePromotionModal.vue?vue&type=template&id=5186e293&scoped=true"
import script from "./DuplicatePromotionModal.vue?vue&type=script&lang=js"
export * from "./DuplicatePromotionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186e293",
  null
  
)

export default component.exports